import { render, staticRenderFns } from "./Mark.vue?vue&type=template&id=f82ce370&scoped=true"
import script from "./Mark.vue?vue&type=script&lang=js"
export * from "./Mark.vue?vue&type=script&lang=js"
import style0 from "./Mark.vue?vue&type=style&index=0&id=f82ce370&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82ce370",
  null
  
)

export default component.exports